<template>
  <div class="robot-sender">
    <!-- 顶部导航栏 -->
    <van-nav-bar title="新建群发" left-text="返回" left-arrow @click-left="handleBack()" fixed safe-area-inset-top />

    <!-- 主要内容区域 -->
    <div class="content">
      <!-- 客户选择区域 -->
      <div class="section">
        <div class="receiver-info">
          <span class="receiver-label">分别发送给</span>
          <span class="receiver-value">{{ receiverDisplay }}</span>
        </div>
      </div>

      <!-- 内容输入区域 -->
      <div class="section">
        <div class="section-title">
          <h3>发送以下内容：</h3>
        </div>
        <!-- 内容类型 -->
        <div class="content-type-container radio-group">
          <van-radio-group v-model="send_msg_type" @change="handleContentTypeChange" direction="horizontal">
            <van-radio name="1">自定义内容</van-radio>
            <van-radio name="2">按营期</van-radio>
          </van-radio-group>
        </div>

        <!-- 自定义内容输入框 -->
        <div v-if="send_msg_type === '1'" class="textarea-container">
          <textarea v-model="messageContent" class="content-textarea" placeholder="请输入群发内容"></textarea>
        </div>

        <!-- 营期选择 -->
        <div v-else-if="send_msg_type === '2'" class="train-container">
          <!-- 营期选择器 -->
          <div class="select-train" @click="showTrainPicker = true">
            <span class="select-train-label">选择营期：</span>
            <div class="selected-trains">
              <div v-if="selectedTrains.length === 0" class="placeholder">请选择营期</div>
              <div v-else class="selected-train-list">
                <van-tag v-for="train in selectedTrains" :key="train.id" closeable @close="removeTrain(train.id)">
                  {{ train.name }}
                </van-tag>
              </div>
            </div>
            <van-icon name="arrow-down" size="14" color="#999" />
          </div>

          <!-- 营期选择弹窗 -->
          <van-popup v-model="showTrainPicker" position="bottom" round @close="handleTrainPickerClose">
            <div class="popup-header">
              <div class="header-left">
                <span class="popup-title">选择营期</span>
                <span class="selected-count">{{ tempSelectedTrains.length }} 个营期已选择</span>
              </div>
              <div class="popup-actions">
                <van-button size="mini" @click="handleTrainPickerClose">取消</van-button>
                <van-button type="primary" size="mini" @click="handleTrainConfirm">确定</van-button>
              </div>
            </div>
            <div class="train-select-header">
              <van-cell clickable @click="handleSelectAllClick">
                <template #title>
                  全选
                </template>
                <template #right-icon>
                  <van-checkbox v-model="selectAllTrains" @change.stop="handleSelectAllChange" />
                </template>
              </van-cell>
            </div>
            <div class="train-list">
              <van-checkbox-group v-model="tempSelectedTrainIds">
                <van-cell v-for="train in trainList" :key="train.id" clickable @click="handleTrainItemClick(train.id)">
                  <template #title>
                    {{ train.name }}
                  </template>
                  <template #right-icon>
                    <van-checkbox :name="train.id.toString()" @change.stop />
                  </template>
                </van-cell>
              </van-checkbox-group>
            </div>
          </van-popup>
        </div>
      </div>

      <!-- 发送时间选择 -->
      <div class="section">
        <div class="section-title">
          <h3>发送时间：</h3>
        </div>
        <!-- 时间类型选择 -->
        <div class="time-type-container radio-group">
          <van-radio-group v-model="send_time_type" @change="handleTimeTypeChange" direction="horizontal">
            <van-radio name="1">指定时间</van-radio>
            <van-radio name="2">每天</van-radio>
          </van-radio-group>
        </div>
        <div class="time-picker-container">
          <!-- 指定时间的选择器 -->
          <van-popup v-if="send_time_type === '1'" v-model="showTimePicker" position="bottom" round closeable
            close-icon-position="top-right" @close="handleTimeClose">
            <div class="popup-header">
              <span class="popup-title">选择发送时间</span>
            </div>
            <van-datetime-picker v-model="tempDateTime" type="datetime" @confirm="handleTimeConfirm"
              @cancel="handleTimeCancel" :min-date="minDate" :seconds-column="true"
              columns-field-names="{ year: 'year', month: 'month', day: 'day', hour: 'hour', minute: 'minute', second: 'second' }"
              :formatter="(type, value) => {
                if (type === 'hour') return `${value}时`;
                if (type === 'minute') return `${value}分`;
                if (type === 'second') return `${value}秒`;
                if (type === 'month') return `${value}月`;
                if (type === 'day') return `${value}日`;
                return value;
              }" />
          </van-popup>

          <!-- 每天的选择器 -->
          <van-popup v-else v-model="showTimePicker" position="bottom" round closeable close-icon-position="top-right"
            @close="handleTimeClose">
            <div class="popup-header">
              <span class="popup-title">选择发送时间</span>
            </div>
            <van-datetime-picker v-model="tempTime" type="time" @confirm="handleTimeConfirmDaily"
              @cancel="handleTimeCancel" :seconds-column="true"
              columns-field-names="{ hour: 'hour', minute: 'minute', second: 'second' }" :formatter="(type, value) => {
                if (type === 'hour') return `${value}时`;
                if (type === 'minute') return `${value}分`;
                if (type === 'second') return `${value}秒`;
                return value;
              }" />
          </van-popup>

          <div class="time-display" @click="showTimePicker = true">
            {{ formatDateTime(sendDateTime) }}
            <van-icon name="arrow-down" size="14" color="#999" />
          </div>

            <!-- 发送方式 -->
            <div class="section" style="margin: 0;padding-bottom: 0;">
                <div class="section-title">
                    <h3>发送方式：</h3>
                </div>
                <div class="radio-group">
                    <van-radio-group v-model="send_content_type" direction="horizontal">
                        <van-radio name="1">普通发送</van-radio>
                        <van-radio name="2">一键群发</van-radio>
                    </van-radio-group>
                </div>
            </div>

            <!-- 消息类型 -->
            <div class="section">
                <div class="section-title">
                    <h3>消息类型：</h3>
                </div>
                <div class="radio-group">
                    <van-radio-group v-model="send_msg_api_type" @change="handleMsgTypeChange" direction="horizontal">
                        <van-radio name="1">普通文本</van-radio>
                        <van-radio name="2">小程序卡片</van-radio>
                    </van-radio-group>
                </div>

                <!-- 小程序卡片内容（仅当 send_msg_api_type === '2' 时显示） -->
                <div v-if="send_msg_api_type === '2'" class="mini-program-container">
                    <div class="form-item">
                        <label class="form-label">分享名称：</label>
                        <input v-model="share_mini_appName" type="text" class="form-input" placeholder="请输入自定义应用名称" />
                    </div>
                    <div class="form-item">
                        <label class="form-label">分享标题：</label>
                        <input v-model="share_mini_title" type="text" class="form-input" placeholder="请输入自定义分享标题" />
                    </div>
                    <div class="form-item">
                        <label class="form-label">分享封面图：</label>
                        <div class="uploader-wrapper">
                            <van-uploader
                                :after-read="onCoverUpload"
                                class="img-uploader"
                                :max-count="1"
                                v-model="coverFileList"
                            />
                            <!-- 遮罩层 -->
                            <div v-show="uploadingCover" class="uploader-mask">
                                <van-loading size="24px" vertical>上传中...</van-loading>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
      </div>

    </div>

    <div class="footer">
      <van-button type="primary" class="send-btn" @click="sendMessage" :loading="loading">发送</van-button>
    </div>

  </div>
</template>

<script>
import {addMsgSendTask, CdnUploadImgLink, getChatWorkRobotTrainList} from '../../api/robot.js';
import { Toast } from 'vant';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      selectedCustomerCount: 2,
      messageContent: '',
      // 内容类型：1=自定义内容，2=按营期
      send_msg_type: '1',
      // 时间类型：1=指定时间，2=每天
      send_time_type: '1',
      // 路由参数
      sendType: '',
      // 时间选择器相关
      sendDateTime: new Date(),
      tempDateTime: new Date(),
      tempTime: new Date(), // 用于每天模式的时间选择器
      minDate: new Date(),
      showTimePicker: false,
      // 营期相关
      trainList: [],
      selectedTrains: [],
      tempSelectedTrainIds: [],
      tempSelectedTrains: [],
      selectAllTrains: false,
      showTrainPicker: false,

        // 新增字段
        send_content_type: '1', // 发送方式：1=普通发送，2=一键群发
        send_msg_api_type: '1', // 消息类型：1=普通文本，2=小程序卡片
        share_mini_appName: '', // 应用名称
        share_mini_title: '',   // 分享标题
        share_mini_cover_image_url: '', // 封面图地址
        CdnUploadImgLink: [], // 封面图CDN信息
        coverFileList: [],       // 封面图文件列表
        loading: false, // 控制发送按钮的 loading 状态
        uploadingCover: false, // 添加这一行，控制封面图上传遮罩层
    };
  },
  created() {
    // 从路由参数中获取发送类型
    this.sendType = this.$route.query.sendType || '';
    console.log('从路由参数获取:', { sendType: this.sendType });
  },

  mounted() {
    // 组件挂载后初始化营期列表
    this.fetchTrainList();
  },
  computed: {
    ...mapGetters('robot', ['selectedTagIds', 'selectedUserIds', 'selectedRoomIds']),
    // 显示接收者信息
    receiverDisplay() {
      if (this.sendType === '3') {
        // 按标签发送
        const tagCount = this.selectedTagIds && Array.isArray(this.selectedTagIds) ? this.selectedTagIds.length : 0;
        return `标签 ${tagCount} 个`;
      } else if (this.sendType === '1') {
        // 按用户发送
        const userCount = this.selectedUserIds && Array.isArray(this.selectedUserIds) ? this.selectedUserIds.length : 0;
        return `客户 ${userCount} 人`;
      } else if (this.sendType === '2') {
        // 按群发送
        const roomCount = this.selectedRoomIds && Array.isArray(this.selectedRoomIds) ? this.selectedRoomIds.length : 0;
        return `群组 ${roomCount} 个`;
      }
      return '';
    }
  },
  methods: {
    ...mapActions('robot', ['clearSelectedUserIds', 'clearSelectedTagIds', 'clearSelectedRoomIds']),
    // 处理指定时间选择确认
    handleTimeConfirm(value) {
      this.sendDateTime = value;
      this.showTimePicker = false;
      console.log('选择的发送时间:', value);
    },

    // 处理每天时间选择确认
    handleTimeConfirmDaily(value) {
      // 安全地处理时间值
      if (!value) {
        console.error('时间值无效:', value);
        return;
      }

      try {
        // 创建一个新的Date对象，使用当前日期但设置选择的时间
        const newDate = new Date(this.sendDateTime);

        if (value instanceof Date) {
          // 如果是Date对象，直接获取时、分、秒
          newDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds());
        } else if (typeof value === 'string') {
          // 处理字符串格式的时间值，如"00:01"或"00:01:00"
          console.error('原始时间字符串:', value);
          const timeParts = value.split(':');
          if (timeParts.length >= 2) {
            const hours = parseInt(timeParts[0], 10);
            const minutes = parseInt(timeParts[1], 10);
            const seconds = timeParts.length >= 3 ? parseInt(timeParts[2], 10) : 0;

            if (!isNaN(hours) && !isNaN(minutes) && !isNaN(seconds)) {
              newDate.setHours(hours, minutes, seconds);
            } else {
              console.error('无法解析的时间部分:', value);
              return;
            }
          } else {
            console.error('无效的时间格式:', value);
            return;
          }
        } else {
          console.error('不支持的时间值类型:', typeof value);
          return;
        }

        this.sendDateTime = newDate;
        this.showTimePicker = false;
        console.log('选择的每天发送时间:', value);
      } catch (error) {
        console.error('处理时间选择时出错:', error);
      }
    },

    // 手动确认时间选择
    confirmTimeSelection() {
      if (this.send_time_type === '2') {
        this.handleTimeConfirmDaily(this.tempTime);
      }
    },

    // 处理时间类型切换
    handleTimeTypeChange(value) {
      // 当切换到每天模式时，准备tempTime的值
      if (value === '2') {
        // 设置tempTime为sendDateTime的当前时间
        const currentTime = new Date(this.sendDateTime);
        this.tempTime = new Date(currentTime);
      }
    },

    // 处理时间选择取消
    handleTimeCancel() {
      this.tempDateTime = new Date(this.sendDateTime);
      this.showTimePicker = false;
    },

    // 处理弹出层关闭
    handleTimeClose() {
      this.tempDateTime = new Date(this.sendDateTime);
      this.showTimePicker = false;
    },

    // 格式化时间为接口要求的格式
    formatDateTime(date) {
      // 确保date是有效的Date对象
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        console.error('无效的日期对象:', date);
        return '--:--:--';
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      console.log('格式化时间 - 时:', hours, '分:', minutes, '秒:', seconds);

      // 根据时间类型返回不同格式
      if (this.send_time_type === '1') {
        // 指定时间：Y-m-d H:i:s
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } else {
        // 每天：H:i:s
        return `${hours}:${minutes}:${seconds}`;
      }
    },

    // 处理内容类型切换
    handleContentTypeChange(value) {
      // 重置消息内容
      this.messageContent = '';
      // 如果切换到营期模式，确保营期列表已加载
      if (value === '2' && this.trainList.length === 0) {
        this.fetchTrainList();
      }
    },

    // 获取营期列表
    fetchTrainList() {
      getChatWorkRobotTrainList()
        .then(res => {
          if (res.code === 1 && res.data) {
            this.trainList = res.data;
          } else {
            Toast.fail('获取营期列表失败');
          }
        })
        .catch(error => {
          console.error('获取营期列表失败:', error);
          Toast.fail('网络错误，请稍后重试');
        });
    },

    // 处理全选点击
    handleSelectAllClick() {
      this.selectAllTrains = !this.selectAllTrains;
      this.handleSelectAllChange(this.selectAllTrains);
    },

    // 处理全选状态变化
    handleSelectAllChange(value) {
      this.selectAllTrains = value;
      if (value) {
        // 全选
        this.tempSelectedTrainIds = this.trainList.map(train => train.id.toString());
        this.tempSelectedTrains = [...this.trainList];
      } else {
        // 取消全选
        this.tempSelectedTrainIds = [];
        this.tempSelectedTrains = [];
      }
    },

    // 处理营期项点击
    handleTrainItemClick(trainId) {
      const idStr = trainId.toString();
      const index = this.tempSelectedTrainIds.indexOf(idStr);

      if (index > -1) {
        // 取消选中
        this.tempSelectedTrainIds.splice(index, 1);
      } else {
        // 选中
        this.tempSelectedTrainIds.push(idStr);
      }

      // 更新临时选中的营期对象列表
      this.tempSelectedTrains = this.trainList.filter(train =>
        this.tempSelectedTrainIds.includes(train.id.toString())
      );

      // 更新全选状态
      this.updateSelectAllStatus();
    },

    // 处理营期选择弹窗关闭
    handleTrainPickerClose() {
      // 重置临时选择
      this.tempSelectedTrainIds = [...this.selectedTrains.map(train => train.id.toString())];
      this.tempSelectedTrains = [...this.selectedTrains];
      this.updateSelectAllStatus();
      this.showTrainPicker = false;
    },

    // 处理营期选择确认
    handleTrainConfirm() {
      // 更新选中的营期
      this.selectedTrains = [...this.tempSelectedTrains];
      // 将选中的营期ID用逗号分隔保存到messageContent
      this.messageContent = this.selectedTrains.map(train => train.id).join(',');
      this.showTrainPicker = false;
    },

    // 移除已选营期
    removeTrain(trainId) {
      const index = this.selectedTrains.findIndex(train => train.id === trainId);
      if (index !== -1) {
        this.selectedTrains.splice(index, 1);
        // 更新messageContent
        this.messageContent = this.selectedTrains.map(train => train.id).join(',');
      }
    },

    // 更新全选状态
    updateSelectAllStatus() {
      this.selectAllTrains = this.tempSelectedTrainIds.length === this.trainList.length;
    },

    // 发送消息
    sendMessage() {
      // 验证消息内容
      if (!this.messageContent) {
        Toast.fail(this.send_msg_type === '1' ? '请输入群发内容' : '请选择营期');
        return;
      }

      // 验证接收对象和发送类型
      if (!this.sendType) {
        Toast.fail('发送类型异常');
        return;
      }

      // 验证对应的ID列表
      let idsValid = false;
      let idList = '';

      if (this.sendType === '3') {
        // 按标签发送
        if (this.selectedTagIds && Array.isArray(this.selectedTagIds) && this.selectedTagIds.length > 0) {
          idsValid = true;
          idList = this.selectedTagIds.join(',');
        }
      } else if (this.sendType === '1') {
        // 按用户发送
        if (this.selectedUserIds && Array.isArray(this.selectedUserIds) && this.selectedUserIds.length > 0) {
          idsValid = true;
          idList = this.selectedUserIds.join(',');
        }
      } else if (this.sendType === '2') {
        // 按群发送
        if (this.selectedRoomIds && Array.isArray(this.selectedRoomIds) && this.selectedRoomIds.length > 0) {
          idsValid = true;
          idList = this.selectedRoomIds.join(',');
        }
      }

      if (!idsValid) {
        Toast.fail('请选择发送对象');
        return;
      }

      // 构建API请求参数
      const requestData = {
        send_time: this.formatDateTime(this.sendDateTime),
        send_time_type: parseInt(this.send_time_type),
        send_msg: this.messageContent,
        send_type: parseInt(this.sendType),
        send_msg_type: parseInt(this.send_msg_type),
        send_content_type: parseInt(this.send_content_type),
        send_msg_api_type: parseInt(this.send_msg_api_type)
      };

      // 根据发送类型添加对应的ID列表
      if (requestData.send_type === 1) {
        requestData.send_user_list = idList;
      } else if (requestData.send_type === 3) {
        requestData.send_tag_list = idList;
      } else if (requestData.send_type === 2) {
        requestData.send_room_list = idList;
      }

        // 当为小程序卡片时，添加额外字段
        if (requestData.send_msg_api_type === 2) {
            if (!this.share_mini_appName) {
                Toast.fail('请输入应用名称');
                return;
            }
            if (!this.share_mini_title) {
                Toast.fail('请输入分享标题');
                return;
            }
            if (!this.share_mini_cover_image_url) {
                Toast.fail('请上传封面图');
                return;
            }

            requestData.share_mini_appName = this.share_mini_appName;
            requestData.share_mini_title = this.share_mini_title;
            requestData.CdnUploadImgLink = this.CdnUploadImgLink;
        }

      console.log('发送请求数据:', requestData);
      console.log('selectedTagIds:', this.selectedTagIds);
      console.log('selectedUserIds:', this.selectedUserIds);

        // 开始加载
        this.loading = true;

      // 调用API发送消息
      addMsgSendTask(requestData)
        .then(res => {

          if (res.code === 1) {
            this.clearData()
            Toast.success('发送成功');

            setTimeout(() => {
              this.$router.push('/robot/labels');
            }, 3000);
          } else {
            Toast.fail(res.msg || '发送失败');
          }
        })
        .catch(error => {
          console.error('发送请求失败:', error);
          Toast.fail('网络错误，请稍后重试');
        })
        .finally(() => {
          // 无论成功或失败，都关闭 loading
          this.loading = false;
        });
    },
    // 处理返回事件
    handleBack() {
      this.clearData();
      this.$router.back();
    },

    clearData() {
      this.clearSelectedUserIds();
      this.clearSelectedTagIds();
      this.clearSelectedRoomIds();
      // 重置内容类型和消息内容
      this.send_msg_type = '1';
      this.send_time_type = '1';
      this.messageContent = '';
      this.selectedTrains = [];
    },

    // 处理消息类型切换
    handleMsgTypeChange(value) {
      if (value === '2') {
          // 清空旧的输入内容
          this.share_mini_appName = '';
          this.share_mini_title = '';
          this.coverFileList = [];
          this.share_mini_cover_image_url = '';
          this.CdnUploadImgLink = '';
      }
    },

    // 封面图上传回调
    onCoverUpload(file) {
        console.log('=== onCoverUpload 被调用 ===');
        console.log('file:', file);
        console.log('file.file:', file.file);

        if (!file.file) {
            console.error('文件对象为空');
            return;
        }
        // 显示遮罩层
        this.uploadingCover = true;

        var formData = new FormData();
        formData.append('image', file.file);

        // 打印请求体
        console.log('formData:', formData);

        CdnUploadImgLink(formData)
        .then(res => {
            console.log('上传成功响应:', res);
            if (res.code === 1) {
                this.share_mini_cover_image_url = res.data.share_mini_cover_image_url;
                this.coverFileList = [{url: res.data.share_mini_cover_image_url}];
                this.CdnUploadImgLink = res.data;
                // Toast.success('上传成功');
            } else {
                Toast.fail(res.msg || '上传失败');
            }
        })
        .catch(error => {
                this.coverFileList = [];
                this.share_mini_cover_image_url = '';
                this.CdnUploadImgLink = '';
                console.error('上传失败:', error);
                Toast.fail('网络错误');
        })
        .finally(() => {
            // 隐藏遮罩层
            this.uploadingCover = false;
        });
    }


  },
  // 监听临时选择变化
  watch: {
    tempSelectedTrainIds: {
      handler(newIds) {
        // 更新临时选中的营期对象列表
        this.tempSelectedTrains = this.trainList.filter(train =>
          newIds.includes(train.id.toString())
        );
        // 更新全选状态
        this.updateSelectAllStatus();
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="less">
.robot-sender {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: var(--base-px-46);
  box-sizing: border-box;
  line-height: 1;

  .content {
    flex: 1;
    overflow-y: auto;
    padding: var(--base-px-20);

    .section {
      background-color: #fff;
      border-radius: var(--base-px-4);
      padding: var(--base-px-16);
      margin-bottom: var(--base-px-20);

      .receiver-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: var(--base-px-14);

        .receiver-label {
          color: #333;
        }

        .receiver-value {
          color: #666;
        }
      }

      .section-title {
        margin-bottom: var(--base-px-15);

        h3 {
          color: #333;
          font-size: var(--base-px-16);
          margin-bottom: var(--base-px-10);
          font-weight: 500;
        }

        .material-btn {
          color: #006eff;
          font-size: var(--base-px-14);
        }
      }

      /* radio组样式 */
      .radio-group {
        margin-bottom: var(--base-px-15);

        .van-radio-group {
          display: flex;
          gap: var(--base-px-20);
        }

        .van-radio {
          font-size: var(--base-px-14);
        }
      }

      .textarea-container {
        margin-bottom: var(--base-px-15);

        .content-textarea {
          width: 100%;
          border: var(--base-px-1) solid #e5e5e5;
          border-radius: var(--base-px-4);
          resize: none;
          font-size: var(--base-px-14);
          line-height: var(--base-px-20);
          min-height: var(--base-px-120);
          outline: none;
          padding: var(--base-px-12);
          box-sizing: border-box;
        }
      }

      .train-container {
        .select-train {
          display: flex;
          align-items: center;
          background-color: #f5f5f5;
          border-radius: var(--base-px-4);
          padding: var(--base-px-12) var(--base-px-16);
          margin-bottom: var(--base-px-15);

          .select-train-label {
            font-size: var(--base-px-14);
            color: #333;
            margin-right: var(--base-px-10);
          }

          .selected-trains {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            gap: var(--base-px-8);

            .placeholder {
              color: #999;
              font-size: var(--base-px-14);
            }

            .selected-train-list {
              display: flex;
              flex-wrap: wrap;
              gap: var(--base-px-8);
            }
          }
        }
      }

      .popup-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: var(--base-px-12) var(--base-px-16);
        border-bottom: var(--base-px-1) solid #eee;

        .header-left {
          display: flex;
          align-items: center;
          gap: var(--base-px-10);
        }

        .popup-title {
          margin-left: var(--base-px-15);
          font-size: var(--base-px-16);
          font-weight: bold;
          color: #333;
        }

        .selected-count {
          font-size: var(--base-px-12);
          color: #666;
        }

        .popup-actions {
          display: flex;
          gap: var(--base-px-10);
        }
      }

      .train-select-header {
        padding: 0;
        border-bottom: var(--base-px-1) solid #f0f0f0;
      }

      .train-list {
        max-height: 40vh;
        overflow-y: auto;
        padding: 0;
      }

      .time-picker-container {
        .time-display {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: var(--base-px-12) var(--base-px-16);
          background-color: #f5f5f5;
          border-radius: var(--base-px-4);
          font-size: var(--base-px-14);
          color: #333;
        }

        .popup-header {
          text-align: center;
          padding: var(--base-px-12) 0;
          border-bottom: var(--base-px-1) solid #eee;

          .popup-title {
            font-size: var(--base-px-16);
            font-weight: bold;
            color: #333;
          }
        }
      }
    }
  }

  .footer {
    background-color: #fff;
    padding: var(--base-px-20);
    border-top: var(--base-px-1) solid #eee;
    margin-top: auto;

    .send-btn {
      width: 100%;
      height: var(--base-px-44);
      border-radius: var(--base-px-4);
      font-size: var(--base-px-16);
      font-weight: 500;
    }
  }
}

/* 覆盖vant按钮样式，确保与labels页面一致 */
::v-deep .van-button--primary {
  background-color: #006eff;
  border-color: #006eff;
}
.mini-program-container {
    margin-top: var(--base-px-15);

    .form-item {
        display: flex;
        align-items: center;
        margin-bottom: var(--base-px-15);

        .form-label {
            width: 100px;
            font-size: var(--base-px-14);
            color: #333;
        }

        .form-input {
            flex: 1;
            border: var(--base-px-1) solid #e5e5e5 !important;
            border-radius: var(--base-px-4) !important;
            padding: var(--base-px-8);
            font-size: var(--base-px-14);
            color: #232323;
        }
    }
}

.uploader-wrapper {
    position: relative;
    display: inline-block;

    .uploader-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: var(--base-px-4);

        .van-loading {
            color: #006eff;
        }
    }
}
</style>
